import React, { Component } from 'react'
import * as Constants from './constants.js'
import $ from 'jquery'
import InstanciaImagen from './instancias/InstanciaImagen.js'
import InstanciaAdjunto from './instancias/InstanciaAdjunto.js';

class AtributoDinamicoInstancia extends Component {
	constructor(props) {
    super(props);
    this.props = props;
  }

	componentDidMount() {
		$('.popover2').popover()
	}

	componentWillUnmount() {
		$('.popover2').popover('hide');
	}

	render() {
			let tipoValor = this.props.atributo.tipoValor ? this.props.atributo.tipoValor : 0
			let InstanciaDinamica = Constants.INSTANCIAS_DICT[tipoValor].clase
			let estadoRequiereInfo = this.props.atributo.estadosInformativos &&
															 this.props.atributo.estadosInformativos.find(estado => estado.id == this.props.atributo.estado)
			let instanciaConEstados = Constants.INSTANCIAS_DICT[tipoValor].conEstados
			let mostrarObservaciones = estadoRequiereInfo && instanciaConEstados && !this.props.previsualizacion
			let isEvidenciaObservacionObligatoria = this.props.atributo.evidencia_observacion_obligatoria > 0 ? true : false
			let isEvidenciaImagenObligatoria = this.props.atributo.evidencia_imagen_obligatoria > 0 ? true : false
			let isEvidenciaDocumentoObligatoria = this.props.atributo.evidencia_documento_obligatoria > 0 ? true : false
      return (
        <React.Fragment>
							<>
								<label className="col-md-3 label-control col-form-label">
									<span className={!this.props.atributo.description ? 'hidden' : ''}>
										<i
											className="cursor-pointer fa fa-info-circle popover2"
											data-toggle="popover" title="Instrucciones"
											onClick={event => event.preventDefault()}
											data-html={true}
											data-content={this.props.atributo.description}
										/>&nbsp;
									</span>

									{this.props.atributo.nombre} {this.props.atributo.required ? '*' : ''}:
								</label>
								<div className={instanciaConEstados ? "col-md-8 col-8 my-auto" : "col-md-9 col-12"}>
									<InstanciaDinamica
										ocultarInput={this.props.ocultarInput}
										disabled={this.props.disabled}
										previsualizacion={this.props.previsualizacion}
										handleChange={this.props.handleChange}
										atributo={this.props.atributo}
										movil={this.props.movil}
									/>
								</div>
								<div className={instanciaConEstados ? "col-md-1 col-4 my-auto" : "hidden"}>
									{this.props.atributo.estado == Constants.ID_ESTADO_APROBACION_VALIDO ?
										<i className="fa fa-2x fa-check success"></i> : ''
									}
									{this.props.atributo.estado == Constants.ID_ESTADO_APROBACION_INVALIDO ?
										<i className="fa fa-2x fa-times-circle-o danger"></i> : ''
									}
								</div>

								{mostrarObservaciones &&
									<>
										<label className="col-md-3 label-control col-form-label">
											Observaciones { isEvidenciaObservacionObligatoria && <>* </> }:
										</label>
										<div className="col-md-9">
											<textarea
												disabled={this.props.disabled}
												className="form-control"
												value={this.props.atributo.observaciones}
												onChange={event => this.props.handleChange("observaciones", event.target.value)}
												rows="1"
											/>
										</div>
										<label className="col-md-3 label-control col-form-label">
											Imagen { isEvidenciaImagenObligatoria && <>* </> }:
										</label>
										<div className="col-md-9">
											<InstanciaImagen
												disabled={this.props.disabled}
												previsualizacion={this.props.previsualizacion}
												valueKey={'adjunto_id'}
												handleChange={(name, value) => this.props.handleChange(name, value)}
												atributo={this.props.atributo}
											/>
										</div>
										<label className="col-md-3 label-control col-form-label">
											Documento { isEvidenciaDocumentoObligatoria && <>* </> }:
										</label>
										<div className="col-md-9">
											<InstanciaAdjunto
												disabled={this.props.disabled}
												previsualizacion={this.props.previsualizacion}
												valueKey={'documento_id'}
												handleChange={(name, value) => this.props.handleChange(name, value)}
												atributo={this.props.atributo}
												accept=".pdf,.doc,.docx,.txt,.xls,.xlsx,.zip,.rar,.mp4,.mp3,.avi,.csv"
											/>
										</div>
									</>
								}
							</>
        </React.Fragment>
      )
  }
}

export default AtributoDinamicoInstancia;
